/*
 * @Author: wangweixin@threatbook.cn
 * @Date: 2018-01-18 17:51:08
 * @Last Modified by: wangweixin
 * @Last Modified time: 2019-02-12 15:34:56
 */
import React, { PureComponent } from 'react'
import classNames from 'classnames'
import ControledInput from '../Common/ControledInput'

@ControledInput(v => v, e => e.target.value)
export default class TextArea extends PureComponent {
  render() {
    const { hasError, className, props: controled, style, ...others } = this.props
    const classes = classNames(
      'input',
      'textarea',
      {
        error: hasError
      },
      className
    )
    return (
      <textarea
        className={classes}
        type="textarea"
        style={style}
        {...others}
        {...controled}
      />
    )
  }
}
